<template>
  <article class="shop-item">
    <div class="shop-item__card">
      <div class="shop-item__body">
        <h3 class="shop-item__title">{{ good.Name }}</h3>
        <ul class="price-list price-list--tablet">
          <li class="price-list__field">
            <label class="price-list__title">Цена:</label>
            <span class="price-list__value">{{ good.Price ? good.Price.toFixed(2) : 0 }} ₽</span>
          </li>
          <li class="price-list__field">
            <label class="price-list__title">Стоимость:</label>
            <span class="price-list__value">{{ amount }} ₽</span>
          </li>
        </ul>
        <div class="shop-item__counter">
          <div class="counter">
            <base-button
              style-class="secondary-text"
              :disabled="!isEqualZero"
              @click="addToCart(-1)"
            >
              <minus-sm-icon />
            </base-button>
            <form-box-input
              v-model="this.good.Quantity"
              type="number"
              placeholder="0"
              :min="0"
              step="1"
              class="counter__input"
              @input="changeCart"
            />
            <base-button
              style-class="secondary-text"
              :disabled="!isLessRest"
              @click="addToCart(1)"
            >
              <plus-sm-icon />
            </base-button>
          </div>
        </div>
      </div>
      <div class="shop-item__footer">
        <ul class="price-list">
          <li class="price-list__field">
            <label class="price-list__title">Цена:</label>
            <span class="price-list__value">{{ good.Price ? good.Price.toFixed(2) : 0 }} ₽</span>
          </li>
          <li class="price-list__field">
            <label class="price-list__title">Стоимость:</label>
            <span class="price-list__value">{{ amount }} ₽</span>
          </li>
        </ul>
      </div>
    </div>
  </article>
</template>

<script>
import cartMixin from "@/mixins/cart";
import { PlusSmIcon, MinusSmIcon } from '@vue-hero-icons/outline';
import BaseButton from '@/components/ui/BaseButton';
import FormBoxInput from '@/components/form/FormBoxInput';

export default {
  name: "ShopItem",

  components: {
    PlusSmIcon,
    MinusSmIcon,
    BaseButton,
    FormBoxInput
  },

  mixins: [cartMixin],

  props: {
    good: {
      type: Object,
    },
    shopId: null,
  },

  computed: {
    amount() {
      if (this.good.Price) {
        return (this.good.Quantity > 0) ? (this.good.Price * this.good.Quantity).toFixed(2) : this.good.Price.toFixed(2);
      }

      return 0;
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../../../sass/variables'
@import '../../../sass/mixins'

.shop-item
  margin-bottom: 16px

.shop-item__card
  padding: 16px
  background: $cBgMain
  box-shadow: 0px 1px 4px rgba(60, 80, 119, 0.16), 0px 1px 2px rgba(60, 80, 119, 0.24)
  border-radius: 16px

  @media screen and (min-width: 768px)
    padding: 24px

.shop-item__body
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  align-items: center
  margin-bottom: 0

  @media screen and (min-width: 768px)
    flex-wrap: nowrap
    align-items: flex-start
    margin-bottom: 16px
  
.shop-item__title
  +TextMain($cTextMain)

  width: 100%
  flex-shrink: 0
  margin-bottom: 8px

  @media screen and (min-width: 768px)
    width: auto
    flex-shrink: 1
    margin-bottom: 0

.shop-item__counter
  margin-left: 0

  @media screen and (min-width: 768px)
    margin-left: 34px

.shop-item__footer
  display: none

  @media screen and (min-width: 768px)
    display: block

.shop-item
  .counter
    display: flex
    flex-wrap: nowrap
    align-items: center
    flex-shrink: 0

  .counter__input
    width: 70px
    margin: 0 8px

  .price-list
    display: flex
    flex-direction: column

    @media screen and (min-width: 768px)
      flex-direction: row
      justify-content: space-between

      &--tablet
        display: none

  .price-list__field
    display: inline-flex
    flex-direction: column

    @media screen and (min-width: 768px)
      display: inline

  .price-list__title
    +Typography($height: 24px, $color: $cLabel)
    margin-right: 8px

  .price-list__value
    +Typography($weight: 700, $height: 24px, $color: $cTextMain)
</style>
